module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-light-italic-58a8a4ccb88be.63e6230.woff2";